import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { Part1Component } from './part1/part1.component';
import { part10Component } from './part10/part10.component';
import { part9Component } from './part9/part9.component';
import { part8Component } from './part8/part8.component';
import { Part6Component } from './part6/part6.component';
import { Part5Component } from './part5/part5.component';
import { Part2Component } from './part2/part2.component';
import { Part4Component } from './part4/part4.component';
import { Part11Component } from './part11/part11.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Part3Component } from './part3/part3.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Part7Component } from './part7/part7.component';
import { Part12Component } from './part12/part12.component';
import { APP_BASE_HREF } from '@angular/common';
import { PopupVideoComponent } from './popup-video/popup-video.component';

@NgModule({
  declarations: [
    AppComponent,
    Part1Component,
    Part2Component,
    Part3Component,
    Part4Component,
    Part5Component,
    Part6Component,
    Part7Component,
    part8Component,
    part9Component,
    part10Component,
    Part11Component,
    Part12Component,
    PopupVideoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [{
    provide: APP_BASE_HREF,
    useValue: '/'
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
